export function formatDateTime(inputDateStr: string) {
  // Convert the input string to a JavaScript Date object
  const date = new Date(inputDateStr);

  // Extract day, month, year, and time components
  const day = date.getDate();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Extract hours and handle 12-hour format conversion
  const startHour24 = date.getHours();
  const startHour = ((startHour24 + 11) % 12) + 1; // Convert to 12-hour format
  const endHour24 = (startHour24 + 1) % 24; // One hour later, in 24-hour format
  const endHour = ((endHour24 + 11) % 12) + 1; // Convert to 12-hour format

  const startAmpm = startHour24 >= 12 ? "PM" : "AM";
  const endAmpm = endHour24 >= 12 ? "PM" : "AM";

  // Construct the final output
  const formattedDate = `${day} ${month} ${year}, ${startHour}:00 ${startAmpm} - ${endHour}:00 ${endAmpm}`;
  return formattedDate;
}
